import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputRightElement, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center, InputRightAddon,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css'
import { MdSettings, MdAdd, MdAddCircleOutline, MdCalendarToday, MdSearch, MdEdit, MdDeleteForever, MdSave } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';

import { FormattedDate, FormattedTime } from 'react-intl';
import { withNamespaces } from 'react-i18next';
import { SUCCESS_STATUS, FAILED_STATUS, FLOOR_LIST } from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiLoadListDepartment, apiLoadADepartment, apiCreateNewDepartment, apiUpdateADepartment, apiDeleteADepartment, 
} from '../../../redux/apis/DepartmentApis';
import { clearADepartmentDetail, clearDepartmentActionStatus } from '../../../redux/actions';
import { getDepartmentList, getADepartment, getDepartmentActionStatus, getDepartmentActionMsg, getDepartmentError } from '../../../redux/selectors';

import NoDataPage from '../../../components/NoData';
import AddEditDepartmentModal from '../Modals/AddEditDeparmentModal';

function Departments({ 
    departmentList, departmentDetail, actionStatus, actionMsg, error, clearADepartmentDetail, clearDepartmentActionStatus,
    apiLoadListDepartment, apiLoadADepartment, apiCreateNewDepartment, apiUpdateADepartment, apiDeleteADepartment, t
}) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const [ searchText, setSearchText ] = useState("");
    const [ isSearching, setIsSearching ] = useState(false);
    const [ isAction, setIsAction ] = useState(false);
    const initialRef = useRef(null);   

    const mounted = useRef();
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        if(!mounted.current) {
            apiLoadListDepartment({ company_id: cookies?.loginCookie?.data?.company_id });
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        } else {
            if(actionStatus === SUCCESS_STATUS) {
                if(isOpen) {
                    onClose();
                }
                toast.success(actionMsg, {
                    position: "bottom-right"
                });
                clearDepartmentActionStatus();
            } 
            else if(actionStatus === FAILED_STATUS) {         
                toast.error(error, {
                    position: "bottom-right"
                });
                clearDepartmentActionStatus();
            }
        }
    });

    useEffect(() => {
        setIsSearching(false);
    }, [departmentList]);

    const handleAddNewDepartment = () => {
        clearADepartmentDetail();
        onOpen();
    }

    const handleUpdateADepartment = (department_id) => {
        apiLoadADepartment({ id: department_id });
    }

    const handleDeleteADepartment = (department_id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>
                            Xác nhận <br />Bạn có muốn xoá phòng khám này không?
                        </h1>
                        <div>
                            <button onClick={onClose}>Huỷ</button>
                            <button
                                onClick={() => {
                                    apiDeleteADepartment({ 
                                        id: department_id, 
                                        payload: { 
                                            company_id: cookies?.loginCookie?.data?.company_id,  
                                            user_id: cookies?.loginCookie?.data?.id,  
                                            is_active: false 
                                        } 
                                    });
                                    onClose();
                                }}
                                className='yes'
                            >
                                Đồng Ý
                            </button>
                        </div>
                    </div>
                )
            },
            closeOnClickOutside: false
        })
    }

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderBottomWidth="2px" px={4} py={2} gap={2} justify="space-between">
                <Button borderRadius={10} colorScheme='orange' onClick={handleAddNewDepartment} isDisabled={!isAction}>
                    <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                    <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Add")}</Text>
                </Button>

                <InputGroup width={{base: "100%", md: "40%", lg: "40%"}}>
                    <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter") {
                            setIsSearching(true);                     
                            setTimeout(() => {
                                apiLoadListDepartment({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' 
                            isLoading={isSearching}
                            loadingText={t("Searching")}
                            onClick={() => {
                                setIsSearching(true);
                                setTimeout(() => {
                                    apiLoadListDepartment({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                                }, 500);
                            }
                        }>
                            {t("Search")}
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>
            
            <PaginatedItems 
                items={departmentList} itemsPerPage={10} onOpen={onOpen} isAction={isAction} t={t}
                handleUpdateADepartment={handleUpdateADepartment} handleDeleteADepartment={handleDeleteADepartment} />
            {
                !(departmentList && departmentList.length > 0) &&
                <NoDataPage text="Hiện tại không có dữ liệu"/>
            }
            {   
                isOpen &&
                <AddEditDepartmentModal 
                    initialRef={initialRef} isOpen={isOpen}  company_id={cookies?.loginCookie?.data?.company_id} 
                    departmentList={departmentList} departmentDetail={departmentDetail} actionStatus={actionStatus} onClose={onClose} 
                    apiCreateNewDepartment={apiCreateNewDepartment} apiUpdateADepartment={apiUpdateADepartment}
                />
            }
            <ToastContainer />
        </React.Fragment>
    )
}

function PaginatedItems({ items, itemsPerPage, onOpen, isAction, handleUpdateADepartment, handleDeleteADepartment, t }) {
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    } 

    return (
        <>
            <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0" textTransform="uppercase">
                            <Th>{t("Index")}</Th>
                            <Th>{t("Name")}</Th>
                            <Th>{t("Specialist")}</Th>
                            <Th>{t("Position")}</Th>
                            <Th>{t("Description")}</Th>
                            <Th>{t("Created_At")}</Th>
                            <Th>{t("Edited_At")}</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            currentItems && currentItems.map((item, idx) => {
                                let workDailyText = "";

                                if(item.work_daily) {
                                    item.work_daily.map(doc => {
                                        workDailyText += workDailyText.length === 0 ? doc.label : ", " + doc.label;
                                    })
                                }

                                return (
                                    <Tr key={item.id}>
                                        <Td>
                                            <Text fontWeight="600">{itemOffset + idx + 1}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.name}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600" color="red">{item.specialist}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.location && FLOOR_LIST[item.location]}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.description}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                            </Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.updated_at &&
                                                <Text fontWeight="600">
                                                    <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td isNumeric>
                                            <Flex direction="row" justifyContent="flex-end" alignContent="center" gap={1}>
                                                <IconButton
                                                    colorScheme='blackAlpha'
                                                    title='Sửa'
                                                    icon={<MdEdit />}
                                                    isDisabled={!isAction}
                                                    onClick={() => {
                                                            onOpen();
                                                            handleUpdateADepartment(item.id);
                                                        }
                                                    }
                                                />
                                                <IconButton
                                                    colorScheme='red'
                                                    title='Xoá'
                                                    icon={<MdDeleteForever />}
                                                    isDisabled={!isAction}
                                                    onClick={() => handleDeleteADepartment(item.id)}
                                                />
                                            </Flex>
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>

            {/* <Flex w="100%" justify="center" my="10px" position={{base: "relative", md: "fixed", lg: "fixed"}} bottom="0px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </Flex> */}
        </>
    )
}

const mapStateToProps = (state) => {
    const departmentList           =   getDepartmentList(state);
    const departmentDetail         =   getADepartment(state);
    const actionStatus             =   getDepartmentActionStatus(state);
    const actionMsg                =   getDepartmentActionMsg(state);
    const error                    =   getDepartmentError(state);

    return { departmentList, departmentDetail, actionStatus, actionMsg, error };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListDepartment:        payload => dispatch(apiLoadListDepartment(payload)),
    apiLoadADepartment:           payload => dispatch(apiLoadADepartment(payload)),
    apiCreateNewDepartment:       payload => dispatch(apiCreateNewDepartment(payload)),
    apiUpdateADepartment:         payload => dispatch(apiUpdateADepartment(payload)),
    apiDeleteADepartment:         payload => dispatch(apiDeleteADepartment(payload)),

    clearADepartmentDetail:       payload => dispatch(clearADepartmentDetail(payload)),
    clearDepartmentActionStatus:  payload => dispatch(clearDepartmentActionStatus(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Departments));